import { ApiClientErrorResponse } from '~/ApiClient';

export default class ItemErrorResponse extends ApiClientErrorResponse {
	handleProductGroupItemNotFound(): boolean {
		return this.handle('product-group-item-not-found');
	}
}
